import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import RejoignezNous from './pages/RejoignezNous';
import Equipe from './pages/Equipe';
import Bibliographie from './pages/Bibligraphie';
import IctConsulting from './pages/IctConsulting';
import RhFormation from './pages/RhFormation';
import EtudesConseilInfo from './pages/EtudeConseil';
import RessourcesHumaines from './pages/RessourceHuamaines';
import WebMedia from './pages/WebMedia';
import NosPartennaires from './pages/Nospartennaires';
import FormationsPage from './pages/Formation';
import InscriptionForm from './pages/Inscription';
import FormationDetail from './pages/DetailFormation';
import PageEnConstruction from './pages/PageEnConstruction';

// Composant pour gérer la navigation et les transitions
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Créer ou récupérer l'indicateur de navigation
    let indicator = document.querySelector('.route-indicator');
    if (!indicator) {
      indicator = document.createElement('div');
      indicator.className = 'route-indicator';
      document.body.appendChild(indicator);
    }

    // Afficher l'indicateur
    indicator.classList.add('active');
    
    // Scroll vers le haut lors du changement de route
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    
    // Ajouter l'animation de transition
    document.body.style.opacity = '0.7';
    document.body.style.transform = 'translateY(10px)';
    document.body.style.transition = 'opacity 0.2s ease-out, transform 0.2s ease-out';
    
    // Animation d'entrée après un court délai
    const enterTimeout = setTimeout(() => {
      document.body.style.opacity = '1';
      document.body.style.transform = 'translateY(0)';
      document.body.style.transition = 'opacity 0.4s ease-in-out, transform 0.4s ease-in-out';
    }, 100);
    
    // Masquer l'indicateur et nettoyer les styles
    const cleanupTimeout = setTimeout(() => {
      indicator.classList.remove('active');
      document.body.style.transition = '';
      document.body.style.opacity = '';
      document.body.style.transform = '';
    }, 500);
    
    // Ajouter une métadonnée sur la page actuelle pour le SEO
    document.title = getPageTitle(location.pathname);
    
    // Nettoyer les timeouts si le composant se démonte
    return () => {
      clearTimeout(enterTimeout);
      clearTimeout(cleanupTimeout);
    };
    
  }, [location.pathname]);

  return null;
};

// Fonction helper pour définir le titre de page
const getPageTitle = (pathname) => {
  const titles = {
    '/': 'Accueil | Aydees',
    '/rejoignez-nous': 'Nous Rejoindre | Aydees',
    '/notre-equipe': 'Notre Équipe | Aydees',
    '/bibliographie': 'Bibliographie | Aydees',
    '/ict-consulting': 'ICT Consulting | Aydees',
    '/rh-formation': 'RH & Formation | Aydees',
    '/etude-conseil': 'Études & Conseils | Aydees',
    '/resources-humaines': 'Ressources Humaines | Aydees',
    '/web-media': 'Web & Média | Aydees',
    '/nos-partennaires': 'Nos Partenaires | Aydees',
    '/formations': 'Formations | Aydees'
  };
  
  return titles[pathname] || 'Page en Construction | Aydees';
};

// Wrapper pour les routes avec animations
const AnimatedRoutes = () => {
  return (
    <div className="min-h-screen">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/rejoignez-nous" element={<RejoignezNous />} />
        <Route path="/notre-equipe" element={<Equipe />} />
        <Route path="/bibliographie" element={<Bibliographie />} />
        <Route path="/ict-consulting" element={<IctConsulting />} />
        <Route path="/rh-formation" element={<RhFormation />} />
        <Route path="/etude-conseil" element={<EtudesConseilInfo />} />
        <Route path="/resources-humaines" element={<RessourcesHumaines />} />
        <Route path="/web-media" element={<WebMedia />} />
        <Route path="/nos-partennaires" element={<NosPartennaires />} />
        <Route path="/formations" element={<FormationsPage />} />
        <Route path="/inscription/:id/:titre" element={<InscriptionForm />} />
        <Route path="/formation-detail/:id/:titre" element={<FormationDetail/>} />
        {/* Route catch-all pour les pages non existantes */}
        <Route path="*" element={<PageEnConstruction />} />
      </Routes>
    </div>
  );
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AnimatedRoutes />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
